import Bg from "assets/img/background/footerBg.svg";
import { Component, ErrorInfo, ReactNode } from "react";
import Button from "../button/button";
import styles from "./error-boundary.module.scss";

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
  errorInfo?: ErrorInfo;
  isDarkMode: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = {
    hasError: false,
    isDarkMode: ErrorBoundary.getCurrentTheme(),
  };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return {
      hasError: true,
      error,
      isDarkMode: ErrorBoundary.getCurrentTheme(),
    };
  }

  private static getCurrentTheme(): boolean {
    if (typeof window !== "undefined") {
      const savedTheme = localStorage.getItem("theme");
      return savedTheme === "dark";
    }
    return false;
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("ErrorBoundary caught an error", error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReload = () => {
    window.location.reload();
    console.log("error");
  };

  render() {
    if (this.state.hasError) {
      const { isDarkMode } = this.state;
      const themeClass = isDarkMode ? styles.darkTheme : "";

      return (
        this.props.fallback || (
          <div className={`${styles.container} ${themeClass}`}>
            <h1 className={styles.title}>Oops! Something went wrong.</h1>
            <p className={styles.description}>Please reload the page.</p>

            {this.state.error && (
              <div className={styles.errorDetails}>
                <pre className={`${styles.errorMessage} ${themeClass}`}>
                  {this.state.error.toString()}
                </pre>
              </div>
            )}

            <Button onClick={this.handleReload}>Reload Page</Button>
            <img src={Bg} alt="" className={styles.bg} />
          </div>
        )
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
